import authQuery from './auth'

export default {
  authQuery
}